/**
 * Helpers pour catégories / types véhicule peuplés côté API ({ _id, name }) ou strings legacy.
 */

export function vehicleRefToId(ref) {
  if (ref == null || ref === '') return '';
  if (typeof ref === 'object' && ref._id != null) return String(ref._id);
  return String(ref);
}

/**
 * Retourne un tableau d'IDs string pour les checkboxes (Add/Edit vehicle).
 */
export function normalizeCategoryIdsFromVehicle(vehicle) {
  const ids = [];
  if (Array.isArray(vehicle?.categories) && vehicle.categories.length > 0) {
    vehicle.categories.forEach((c) => {
      const id = vehicleRefToId(c);
      if (id) ids.push(id);
    });
  }
  if (ids.length === 0 && vehicle?.category) {
    const id = vehicleRefToId(vehicle.category);
    if (id) ids.push(id);
  }
  if (ids.length === 0 && vehicle?.vehicleType) {
    const id = vehicleRefToId(vehicle.vehicleType);
    if (id) ids.push(id);
  }
  return [...new Set(ids)];
}

/**
 * Libellé affichable pour une seule catégorie / ref.
 */
export function formatCategoryLabel(value) {
  if (value == null || value === '') return 'N/A';
  if (typeof value === 'object') {
    return value.name || value.label || (value._id != null ? String(value._id) : 'N/A');
  }
  return String(value);
}

/**
 * Libellés pour plusieurs catégories (liste ou tableau peuplé).
 */
export function formatCategoriesDisplay(categories) {
  if (!Array.isArray(categories) || categories.length === 0) return 'N/A';
  return categories
    .map((c) => formatCategoryLabel(c))
    .filter((s) => s && s !== 'N/A')
    .join(', ') || 'N/A';
}

/**
 * Texte pour afficher catégorie(s) à partir du document véhicule complet.
 */
export function formatVehicleCategoriesFromDoc(vehicle) {
  if (!vehicle) return 'N/A';
  if (Array.isArray(vehicle.categories) && vehicle.categories.length > 0) {
    return formatCategoriesDisplay(vehicle.categories);
  }
  if (vehicle.category) {
    return formatCategoryLabel(vehicle.category);
  }
  if (vehicle.vehicleType) {
    return formatCategoryLabel(vehicle.vehicleType);
  }
  return 'N/A';
}
